import type { LoanPortfolioQuery } from '@taler/api-client'
import { loanKeys } from '@taler/api-client'
import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { useApi } from '@/app/api'
import { useDisplayCurrency } from '@/app/display-currency'

export interface UseLoanSummaryOptions {
  readonly ledgerId: () => string | undefined
  readonly enabled: () => boolean
}

export function useLoanSummary(options: UseLoanSummaryOptions) {
  const api = useApi()
  const { displayCurrency } = useDisplayCurrency()
  const query = computed<LoanPortfolioQuery>(() => ({
    displayCurrency: displayCurrency.value as LoanPortfolioQuery['displayCurrency'],
  }))
  const active = computed(() => options.enabled() && options.ledgerId() !== undefined)

  const summaryQuery = useQuery({
    queryKey: computed(() => loanKeys.summary(options.ledgerId() ?? '', query.value)),
    queryFn: ({ signal }) => api.loans.summary(options.ledgerId()!, query.value, signal),
    enabled: active,
    retry: false,
  })

  return {
    portfolio: computed(() => (active.value ? summaryQuery.data.value : undefined)),
  }
}
